import { Col, Row } from "react-bootstrap";

import ContactData from "../../data/contact.json"
import React from "react";

export const Privacy = () => {

	const rowStyle = {
		color: 'white',
		backgroundColor: 'black',
		padding: '5vh 10vw  20vh  10vw',
	};


	return (
		<Row style={rowStyle}>
			<Col md={12} className="">
				<h2 className="text-center"><strong >Informativa sulla Privacy</strong></h2><br /><br />
				<p>
					In conformità con il Regolamento Generale sulla Protezione dei Dati (RGPD) dell'Unione Europea e le leggi nazionali italiane sulla protezione dei dati personali, la presente Informativa sulla Privacy descrive le pratiche di Ducato S.R.l. (di seguito "noi", "nostro" o "azienda") riguardo alla gestione dei dati personali nel contesto del nostro sito web.
				</p>
				<p>
					<strong >Raccolta di Dati</strong><br />
					Il nostro sito web, accessibile all'indirizzo {ContactData.siteAdress}, non raccoglie alcun tipo di dato personale identificabile. Non utilizziamo cookie o altre tecnologie di tracciamento per monitorare l'attività degli utenti. Rispettiamo la tua privacy e non registriamo informazioni personali o identificabili durante la tua visita.
				</p>
				<p>
					<strong >Dati Automatici</strong><br />
					Il provider che ci fornisce il servizio di hosting del nostro server web può raccogliere automaticamente alcune informazioni non personali durante la navigazione, come l'indirizzo IP del dispositivo utilizzato per accedere al sito, il tipo di browser, il sistema operativo e le pagine visitate. Si tratta di dati relativi al traffico telematico, che per loro natura non sono raccolti per essere associati immediatamente ad interessati identificati, ma che potrebbero, tramite elaborazioni o associazioni con dati detenuti da terzi, permettere di identificare gli utenti/visitatori del sito. Questi dati sono eventualmente utilizzati al solo fine di controllare il corretto funzionamento del sito web e vengono cancellati immediatamente dopo la elaborazione. 
				</p>
				<p>
					<strong >Finalità del Trattamento</strong><br />
					Non raccogliamo dati personali e non elaboriamo alcuna informazione per identificare gli utenti. Non vendiamo, condividiamo o trasferiamo dati personali a terzi.
				</p>
				<p>
					<strong >Diritti dell'Interessato</strong><br />
					In base alle leggi vigenti, sei titolare di specifici diritti in merito ai tuoi dati personali, anche se non sono raccolti dal nostro sito. Hai il diritto di richiedere informazioni sul trattamento dei dati, di ottenere l'accesso a eventuali dati personali trattati, di correggere eventuali dati inesatti e di opporsi al trattamento. Per esercitare questi diritti o per porre domande sulla nostra politica di privacy, puoi contattarci utilizzando i dati di contatto riportati di seguito.
				</p>
				<p>
					<strong >Contatti</strong><br />
					{ContactData.name}<br /><span dangerouslySetInnerHTML={{ __html: ContactData.adressMain }} /><br />P.Iva: {ContactData.vat}<br />Email: <a href={`mailto:${ContactData.emailAddress}`} style={{color:'white'}}>{ContactData.emailAddress}</a>
				</p>
				<p>
					<strong >Aggiornamenti</strong><br />
					Questa Informativa sulla Privacy è soggetta a modifiche e aggiornamenti. Ti consigliamo di verificarla periodicamente per rimanere informato sulle nostre pratiche di trattamento dei dati.
					<br />
					Ultimo aggiornamento: 30 ottobre 2023
				</p>

			</Col>
		</Row>
	);
};
